
import React, { useEffect, useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import CheckIcon from "@mui/icons-material/Check";

const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "te", label: "Telugu", native: "తెలుగు" },
];

function LanguageSwitcher() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentCode, setCurrentCode] = useState("en");

  const open = Boolean(anchorEl);

  useEffect(() => {
    const checkGoogleTranslate = setInterval(() => {
      const select = document.querySelector(".goog-te-combo");

      if (select) {
        setCurrentCode(select.value || "en");
        clearInterval(checkGoogleTranslate);
      }
    }, 500);

    return () => clearInterval(checkGoogleTranslate);
  }, []);

  const currentLang =
    LANGUAGES.find((lang) => lang.code === currentCode) ||
    LANGUAGES[0];
console.log(currentLang)
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (code) => {
    handleClose();

    const googleTranslateSelect =
      document.querySelector(".goog-te-combo");

    if (!googleTranslateSelect) {
      console.error("Google Translate is not initialized yet.");
      return;
    }

    console.log("Changing language to:", code);

    googleTranslateSelect.value = code;

    googleTranslateSelect.dispatchEvent(
      new Event("change", {
        bubbles: true,
      })
    );

    setCurrentCode(code);
  };

  return (
    <>
      <Button
        className="notranslate"
        translate="no"
        onClick={handleOpen}
        startIcon={<LanguageIcon />}
        size="small"
        sx={{
          textTransform: "none",
          color: "inherit",
          minWidth: "auto",
          px: 1.5,
        }}
      >
        {currentLang.native}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{marginTop:2}}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === currentCode}
            onClick={() => handleSelect(lang.code)}
          >
            {lang.code === currentCode && (
              <ListItemIcon sx={{ minWidth: 28 }}>
                <CheckIcon fontSize="small" />
              </ListItemIcon>
            )}
            <ListItemText
              inset={lang.code !== currentCode}
              primary={lang.native}
              secondary={
                lang.label !== lang.native ? (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                  >
                    {lang.label}
                  </Typography>
                ) : null
              }
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default LanguageSwitcher;